import React, { useContext, useEffect, useState } from "react";
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
import HeaderInner from "../../Components/HeaderInner";
import MaintenanceLoader from "../../Components/Loaders/MaintenanceLoader";
import { Zoom } from "react-reveal";
import { ShowITs } from "../../API/ITAPI";
import { Button, Col, Form, Modal, Row } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import PhoneInput from "react-phone-input-2";
import ModalIT from "./ModalIT";
import Search from "../../Components/Search";
import Title from "../../new-components/title/Title";
import NewFooter from "../../NewFooter";
import { ThemeContext } from "../../context/ThemeContext";
import { useBusinessNameContext } from "./../../context/BusinessName";
import useMixpanel from "../../hooks/useMixpanel";

function ITs() {
  const { businessName, setBusinessName } = useBusinessNameContext();
  const { track } = useMixpanel();
  const location = useLocation();
  const rawPath = location.pathname;
  const room_uuid = rawPath.split("/")[1];
  const euuid = rawPath.split("categories/")[1];
  const navigate = useNavigate();
  const params = useParams();
  const lang = localStorage.getItem("lang");

  const [show, setShow] = useState(false);
  const [loading, setLoading] = useState(false);
  const [phone, setPhone] = useState();
  const [category, setCategory] = useState();
  const [textMod, setTextMod] = useState();
  const [selectedCategory, setSelectedCategory] = useState();
  const { theme } = useContext(ThemeContext);
  const handleShow = (id, text, category) => {
    setCategory(id);
    setTextMod(text);
    setShow(true);
    setSelectedCategory(category);
  };
  const { t, i18n } = useTranslation();
  let flowers;
  let bgColor;
  let color;
  let text;
  let company_id;
  let itCategories;
  const { data, isLoading, error } = ShowITs(room_uuid, params.uuid, lang);
  if (!isLoading) {
    if (error) {
      if (error?.response.status == 404) {
        navigate(`/not-found`);
      }
    } else {
      if (data.data.status === false) {
        navigate(`/${room_uuid}/qr-scan`);
      } else {
        flowers = data.data.data;
        itCategories = flowers.itCategories;
        company_id = flowers.company.id;
        bgColor = flowers.header_color;
        text = flowers.title;
      }
    }
  }
  useEffect(() => {
    window.scrollTo({
      top: 0,
      left: 0,
    });
  }, []);

  return (
    <div className={theme ? "food pb-0" : ""}>
      {theme ? <Title title={text} /> : <HeaderInner headerName={text} />}
      <main
        className="home-main bg-white maintenances mb-0 min-height-0"
        style={{ paddingTop: "80px" }}
      >
        <Search
          placeholder="Search for Categories..."
          room_uuid={room_uuid}
          category="IT"
        />

        <div className="display-list three-items v2 v3  ">
          {isLoading ? (
            <MaintenanceLoader />
          ) : itCategories ? (
            itCategories.map((x, idx) => {
              return (
                <li
                  id={x.name}
                  key={idx}
                  onClick={(id) => {
                    handleShow(x.id, x.name, x);
                    track.menuItemViewed({
                      item_id: x.id,
                      item_name: x.name,
                      category_name: "IT",
                      price: 0,
                    });
                  }}
                >
                  <Zoom>
                    <a onClick={(id) => handleShow(x.id, x.name, x)}>
                      <div className="img-pnl"></div>
                      <img src={x.image} alt="" />
                      <div></div>
                      <div className="bg-layer"></div>
                    </a>
                    <p>{x.name}</p>
                  </Zoom>
                </li>
              );
            })
          ) : null}
        </div>
      </main>
      {theme && <NewFooter />}
      <ModalIT
        show={show}
        setShow={setShow}
        category={category}
        room_uuid={room_uuid}
        text={textMod}
        company_id={company_id}
        theme={theme}
        selectedCategory={selectedCategory}
        requiredFields={{
          nameRequired: flowers?.name_required,
          emailRequired: flowers?.email_required,
          phoneRequired: flowers?.phone_required,
        }}
      />
    </div>
  );
}
export default ITs;
